export function transpileSettings(prevSettings) {
    if (!prevSettings) {
        console.warn('transpileSettings got empty prevSettings',prevSettings)
        return prevSettings
    }
    // debugger
    if (prevSettings.version === 3) {
        return prevSettings
    } else {
        console.log('prevSettings',prevSettings);
        let newSettings = {
            activeDotsColor: prevSettings.activeDotsColor,
            animationMode: prevSettings.animationMode,
            animationsOnHover: false,
            // проверить номера стрелок
            arrows: prevSettings.arrows > 7 ? prevSettings.arrows - 1 : prevSettings.arrows,
            captionPlayMode: prevSettings.captionPlayMode,
            deviceType: 'desktop',
            dotsType: (!prevSettings.hasParallax && prevSettings.hasDots) ? 'outer' : 'none',
            dotsColor: prevSettings.dotsColor,
            dotsSize: prevSettings.dotsSize,
            dotsSpacing: 10,
            hasArrows: prevSettings.hasArrows,
            // // hasBackgroundTransparency: Boolean,
            hasDisableRightClick: prevSettings.hasDisableRightClick,
            // когда включён параллакс точки отклчены
            hasDots: !prevSettings.hasParallax && prevSettings.hasDots,
            hasNavigationOnHover: prevSettings.hasNavigationOnHover,
            hasParallax: prevSettings.hasParallax,
            hasMobileDots: false,
            hasWidgetBgColor: false,
            hoverDotsColor: prevSettings.hoverDotsColor,
            mobileDotsSize: 3,
            parallaxImage: [getParallaxImage(prevSettings.parallaxImage[0])],
            // остановился проверять тут
            parallaxType: 'classic',
            templatePreview: {
                needShow: false,
                templateIndex: 0,
            },
            pauseDuration: prevSettings.pauseDuration > 1000 ? prevSettings.pauseDuration : 1000,
            sensivity: 20,
            slideAnimationSpeed: prevSettings.slideAnimationSpeed,
            sliderMode: prevSettings.sliderMode,
            slides: getSlides(prevSettings.slides, prevSettings.hasParallax),
            toasts: [
                { id: 1, message: 'Right click to edit text' },
                { id: 2, message: 'Arrows + "Shift" for 10px movement' },
                { id: 3, message: 'If you hide elements on the mobile version, it will not be hidden in the desktop version and vice-versa' },
            ],
            version: 3,
            widgetDimensions: {
                width: prevSettings.widgetDimensions.width,
                height: prevSettings.widgetDimensions.height,
                mobileWidth: prevSettings.widgetMobileDimensions.width,
                mobileHeight: prevSettings.widgetMobileDimensions.height,
                // editedWidth: prevSettings.widgetDimensions.width,
                // editedHeight: prevSettings.widgetDimensions.height,
                // editedWidthMobile: prevSettings.widgetMobileDimensions.width,
                // editedHeightMobile: prevSettings.widgetMobileDimensions.height,
            },
            widgetBgColor: "rgba(255,255,255,0)",
            lastDateUpdate: 2
        };
        return newSettings;
    }
    function getParallaxImage(prevImage) {
        let newImage = {
            fileName: prevImage.fileName,
            height: prevImage.height,
            offsetX: 0,
            offsetY: 0,
            mobileScale: 1,
            mobileOffsetX: 0,
            mobileOffsetY: 0,
            scale: 1,
            // spaceY: 0,
            relativeUri: prevImage.relativeUri,
            width: prevImage.width
        };
    
        return newImage
    }
    
    function getSlides(prevSlides, hasParallax) {
        let newSlides = []
        console.log('hasParallax',hasParallax)
    
        prevSlides.map((prevSlide, index) => {
            if (hasParallax) {
                const regex = /(\d+(\.\d+)?\))/;
                const opacityBackground = prevSlide.backgroundColor.match(regex)[0]
                prevSlide.backgroundColor = prevSlide.backgroundColor.replace(opacityBackground, 0 + ')')
            }
            newSlides.push({
                backgroundColor: prevSlide.backgroundColor,
                backgroundType: 'color',
                backgroundGradient: [{
                    angle: 45,
                    firstColor: "rgba(251, 247, 173, 1)",
                    secondColor: "rgba(80, 196, 237, 1)",
                    transition: 100,
                }],
                captions: getCaptions(prevSlide.captions, prevSettings.widgetDimensions.height),
                hasBackgroundShadow: prevSlide.hasBackgroundShadow,
                backgroundShadow: {
                    angle: 0,
                    distance: 0,
                    x: 0,
                    y: 0,
                    blur: 20,
                    size: 10,
                    color: 'rgba(0,0,0,0.3) inset',
                },
                index: index,
                slideName: prevSlide.slideName,
                isHide: false,
                editedHeight: prevSettings.widgetDimensions.height,
                editedWidth: prevSettings.widgetDimensions.width,
                editedHeightMobile: prevSettings.widgetMobileDimensions.height,
                editedWidthMobile: prevSettings.widgetMobileDimensions.width,
                slideJustTranspiled: true // означает, что слайд только что сконвертирован 
            })
        })
    
        return newSlides
    }
    
    function getCaptions(prevCaptions, desktopWidth) {
        let newCaptions = []
    
        prevCaptions.map((prevCaption, index) => {
            newCaptions.push({
                //=========!!Common!!=========
    
                animationIn: prevCaption.animationIn,
                animationOut: prevCaption.animationOut,
                animationModeIn: prevCaption.animationModeIn,
                animationModeOut: prevCaption.animationModeOut,
                backgroundColor: prevCaption.backgroundColor,
                backgroundColorHover: prevCaption.backgroundColorHover,
                borderWidth: prevCaption.borderWidth,
                borderRadius: prevCaption.borderRadius,
                borderColor: prevCaption.borderColor,
                borderColorHover: prevCaption.borderColorHover,
                boxId: '',
                delayIn: prevCaption.delayIn,
                delayOut: prevCaption.delayOut,
                fontColor: prevCaption.fontColor,
                fontColorHover: prevCaption.fontColorHover,
                fontFamily: {
                    label: '',
                    value: prevCaption.fontFamily,
                },
                fontShadow: prevCaption.fontShadow,
                fontSize: prevCaption.fontSize,
                hasShadow: prevCaption.fontShadow,
                id: `id-${Date.now() + parseInt(Math.random() * 1000)}`,
                index: index,
                isHover: prevCaption.onClick === "navigateTo",
                layer: prevCaption.layer,
                letterCase: 'none',
                letterSpacing: 0,
                // linkTo - новая настройка
                linkTo: getLinkTo(prevCaption),
                
                // linkType: {
                //     label: prevCaption.linkType,
                //     value: prevCaption.linkType,
                // },
                // link: getLink(prevCaption),
                lineHeight: 100,
                mobileBorderRadius: prevCaption.borderRadius,
                mobileBorderWidth: prevCaption.borderWidth,
                mobileBoxId: '',
                mobileFontSize: 10,
                mobileLetterSpacing: 0,
                mobileLineHeight: 100,
                mobileShow: true,
                mobilePadding: 0,
                mobilePosition: {
                    x: 10,
                    y: 10,
                    relativeX: 0,
                    relativeY: 0,
                },
                needMobileConvert: true,
                onClick: {
                    label: prevCaption.onClick === "doNothing" ? "Do nothing" : "Go to link",//"Go to link" - для курсора pointer
                    value: prevCaption.onClick === "doNothing" ? "doNothing" : "goToLink"//"goToLink"
                },
                padding: prevCaption.padding,
                position: {
                    x: prevCaption.position.x,
                    y: prevCaption.position.y,
                    relativeX: 0,
                    relativeY: 0,
                },
                shadow: {
                    angle: 120,
                    distance: 2,
                    x: 2,
                    y: 1,
                    blur: 4,
                    size: 1,
                    color: 'rgba(0,0,0,0.7)',
                },
                style: {
                    bold: prevCaption.style.bold,
                    italic: prevCaption.style.italic,
                    underline: false,
                    textAlign: 'center',
                },
                text: prevCaption.text,
                type: 'text',
                width: desktopWidth - prevCaption.position.x,
                height: prevCaption.fontSize,
                mobileWidth: 52,
                mobileHeight: 16,
    
                //===========!!Button!!==============
    
                // animation: {
                //     value: String,
                //     label: String,
                // },
    
                //===========!!Box!!================
    
                // height: Number,
                // width: Number,
                // mobileHeight: Number,
                // mobileWidth: Number,
            })
        })
    
        return newCaptions;
    }
    
    function getLink(prevCaption) {
        switch (prevCaption.linkType) {
            case 'anchor':
                return {
                    label: 'Anchor',
                    value: prevCaption.wixAnchor
                }
    
            case 'link':
                return prevCaption.link
    
            case 'page':
                return {
                    label: 'Anchor',
                    value: prevCaption.wixPage
                }
    
        }
    }
    
            // =========pageId======
            // onClick: "navigateTo",
            // linkType: "wix",
            // wixPage: "#bxq66",
            // wixAnchor: "",
            // link: "https://ru.wix.com/",
    
            // ======anchor========
            // onClick: "navigateTo",
            // linkType: "anchor",
            // wixPage: "#c1dmp",
            // wixAnchor: "PAGE_TOP_ANCHOR",
            // link: "https://ru.wix.com/",
    
            // ========link==========
            // onClick: "navigateTo",
            // linkType: "link",
            // wixPage: "#c1dmp",
            // wixAnchor: "",
            // link: "https://www.michaelkocherov.ru/",
    
            // ========do nothing========
            // onClick: "doNothing",
            // linkType: "wix",
            // wixPage: "",
            // wixAnchor: "",
            // link: "https://ru.wix.com/",
    
    
            // case 'page':
            //     obj.pageId = navigateTo.linkTo.pageId
            //     obj.type = 'PageLink'
            //     break;
            // case 'anchor':
            //     obj.anchorDataId = '#' + navigateTo.linkTo.id
            //     obj.anchorName = navigateTo.linkTo.title
            //     obj.type = "AnchorLink"
            //     break;
            // case 'web':
            //     obj.type = "ExternalLink"
            //     obj.url = navigateTo.linkTo
            //     break;
    
    function getLinkTo(prevCaption) {
        const link = {}
        switch (prevCaption.linkType) {
            case 'wix':
                link.pageId = prevCaption.wixPage
                link.type = 'PageLink'
                link.target = "_self"
                break;
            case 'page':
                link.pageId = prevCaption.wixPage
                link.type = 'PageLink'
                link.target = "_self"
                break;
            case 'anchor':
                link.type = "AnchorLink"
                link.pageId = prevCaption.wixPage
                link.anchorName = prevCaption.wixAnchor
                link.anchorDataId = ''
                break;
            case 'web':
                link.type = "ExternalLink"
                link.url = prevCaption.link
                link.target = "_blank"
                break;
            case 'link':
                link.type = "ExternalLink"
                link.url = prevCaption.link
                link.target = "_blank"
                break;
        }
        return link
    }
    
    // pageId
    // linkTo:{
    //     pageId: "#bxq66",
    //     target: "_self",
    //     type: "PageLink"
    // }
    
    // anchor
}

    
    